export const getCookie = (key, defaultValue) => {
  const kvs = document.cookie.split("; ");
  const record = kvs.filter((kv) => kv.split("=")[0].trim() === key);
  if (record.length === 0) {
    return defaultValue;
  }
  return record[0].split("=")[1];
};
